<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('adicionar-cultura') }}
                        </h1>
                    </div>
                    <div class="header-buttons">
                        <button class="delete-btn" type="button" @click="onFecharModal">
                            {{ $t('cancelar') }}
                        </button>
                        <button
                            v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-12">
                            <v-input
                                :id="generateId(1)"
                                ref="descricaoInput"
                                v-model="tipocultura.descricao"
                                :placeholder="'descricao-do-tipo-cultura-placeholder'"
                                :maxlength="30"
                                title="descricao"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="isNull(tipocultura.descricao)"
                                :required="true"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TipoCulturaService from '@/services/agro/CulturaService';
import TipoCulturaValidation from '@/services/validations/TipoCulturaValidation';
import Message from '@/models/Message';
import { mapState } from 'vuex';

export default {
    props: {
        culturaProdutoIntegracao: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            service: new TipoCulturaService(this.$http, this.$router),
            validation: new TipoCulturaValidation(this.msgs),
            isLoading: false,
            msgs: [],
            isSaving: false,
            tipocultura: {
                idtipocultura: null,
                idtipoculturaerp: null,
                descricao: null,
                situacao: null,
                replicapda: null,
            },
            isUpdate: false,
            situacao: { label: 'ativo', id: 1 },
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            'vendas',
            'produtos',
            'ven-produto-dados-cadastrais-cultura'
        );

        if (!this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'aba-cultura' },
            });
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        save() {
            this.isLoading = true;
            let tempTipocultura = Object.assign({}, this.tipocultura);
            if (this.validation.validate(tempTipocultura, this.$refs)) {
                tempTipocultura = this.mapTosave(tempTipocultura);
                this.isSaving = true;
                this.service
                    .save(tempTipocultura)
                    .then((value) => {
                        if (value.message == null) {
                            let msg =
                                this.tipocultura.idtipocultura != null
                                    ? 'msg-tipocultura-edita'
                                    : 'msg-tipocultura-salva';
                            this.msgs.push(new Message('success', msg, true));
                            this.promptConfirmaVinculo(value.content);
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        if (e.body.status == 409) {
                            this.msgs.push(new Message('alert', e.body.message, true));
                        } else {
                            console.error('Erro ao salvar: ' + e);
                            this.msgs.push(new Message('error', 'msg-erro-salvar', true));
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },

        promptConfirmaVinculo(cultura) {
            if (this.culturaProdutoIntegracao) {
                setTimeout(() => this.$emit('fecharModal'), 1500);
            } else {
                this.$root.confirm({
                    message: this.$t('deseja-realizar-vinculo'),
                    onConfirm: (_) => {
                        this.$emit('cadastrado', cultura);
                    },
                    onCancel: (_) => {
                        this.$emit('fecharModal');
                    },
                });
            }
        },
        onFecharModal() {
            this.$emit('fecharModal', true);
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
